export default __webpack_public_path__ + "static/media/header-image.3c162870.svg";